import { Store } from 'pullstate';

import type { AlertId, SimpleRasAlertAddData } from '../utils/alerts';

export interface IAlertsStore {
  aside: Record<AlertId, SimpleRasAlertAddData>;
  main: Record<AlertId, SimpleRasAlertAddData>;
  toast: Record<AlertId, SimpleRasAlertAddData>;
}

export const AlertsStore = new Store<IAlertsStore>({
  aside: {},
  main: {},
  toast: {},
});
